'use strict';
const angular = require('angular');

export default angular.module('wftOrderFormApp.pagination', [])
  .directive('pagination', function() {
    return {
      template: '<div class="pagination-nav pull-right">\
        <nav ng-if="pageNums.length">\
          <ul class="pagination pagination-sm">\
            <li ng-class="pageNum == 1 ? \'disabled\' : \'\'"><a ng-click="firstPage()"><span aria-hidden="true">First</span><span class="sr-only">First</span></a></li>\
            <li ng-class="pageNum == 1 ? \'disabled\' : \'\'"><a ng-click="selectPrevPage()"><span aria-hidden="true">«</span><span class="sr-only">Previous</span></a></li>\
            <li ng-repeat="num in pageNums track by $index" ng-class="{\'active\': pageNum === num}"><a ng-click="selectPage(num)">{{num | currency:\'\':0}} <span class="sr-only" ng-if="num == pageNum">(current)</span></a></li>\
            <li ng-class="pageNum == totalPages ? \'disabled\' : \'\'"><a ng-click="selectNextPage()"><span aria-hidden="true">»</span><span class="sr-only">Next</span></a></li>\
            <li ng-class="pageNum == totalPages ? \'disabled\' : \'\'"><a ng-click="lastPage(totalPages)"><span aria-hidden="true">Last</span><span class="sr-only">Last</span></a></li>\
          </ul>\
        </nav>\
      </div>',
      restrict: 'E',
      replace: true,
      scope: {
        id: '<',
        total: '<',
        pageNum: '<',
        pageSize: '<',
        callback: '&'
      },
      link: function(scope) {
        scope.curPageNum = 1;
        scope.maxTotalPageDisplay = 5;

        scope.pageNums = [];
        scope.totalPages = 0;
        scope.pageNum = 1;

        function calTotalPages() {
          scope.pageNums = [];
          if(scope.total > 1 && scope.total > scope.pageSize) {
            scope.totalPages = Math.ceil(scope.total / scope.pageSize);
            var startAt = 1; // start at
            var endAt = scope.totalPages;
            if(scope.totalPages > scope.maxTotalPageDisplay) {
              startAt = scope.pageNum;
              // find max for both direction
              var maxBothDir = Math.floor(scope.maxTotalPageDisplay / 2);
              var maxCombo = maxBothDir*2;
              var newStartAt = startAt - maxBothDir;
              if (newStartAt <= 0) {
                newStartAt = 1;
                var newEndAt = newStartAt + maxCombo;
              } else {
                var newEndAt = newStartAt + maxCombo;
                if (newEndAt > scope.totalPages) {
                  newStartAt = scope.totalPages - maxCombo;
                  newEndAt = scope.totalPages;
                }
              }
              startAt = newStartAt;
              endAt = newEndAt;
            }
            // create display
            for(startAt; startAt <= endAt; startAt++) {
              scope.pageNums.push(startAt);
            }
            //console.log(scope.pageNums);
          }
        };

        scope.$watchGroup(['total', 'pageNum', 'pageSize'], function(v) {
          if(v[0] && v[1] && v[2]) {
            calTotalPages();
          }
        });

        scope.selectPrevPage = function() {
          var pageNum = scope.pageNum - 1;
          if(pageNum > 0) {
            calTotalPages();
            scope.selectPage(pageNum);
          }
        };

        scope.selectNextPage = function() {
          var pageNum = scope.pageNum + 1;
          if(pageNum < scope.totalPages) {
            calTotalPages();
            scope.selectPage(pageNum);
          }
        };

        scope.firstPage = function() {
          scope.pageNum = 1;
          scope.curPageNum = 1;
          calTotalPages();
          scope.selectPage(1);
        };

        scope.lastPage = function(pageNum) {
          scope.curPageNum = pageNum;
          calTotalPages();
          scope.selectPage(pageNum);
        };

        scope.selectPage = function(pageNum) {
          if(parseInt(pageNum) <= scope.totalPages) {
            scope.pageNum = pageNum;
            scope.curPageNum = pageNum;
            calTotalPages();
            scope.callback({pageNum: pageNum});
          }
        };
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/pagination/pagination.directive.js